import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpRequestService } from './http-request.service';

export interface DashboardStats {
  general_contractor_count: number;
  user_count: number;
  project_count: number;
  sub_contractor_count: number;
  supply_count: number;
  requisition_count: number;
  supplier_count: number;
  requisition_labour_count: number;
  supply_labour_count: number;
  registration_trend: any[];
}

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private readonly API = '/dashboard/get-count/'; // 🔁 replace

  constructor(private http: HttpRequestService) {}

  getStats(): Observable<DashboardStats> {
    return this.http.request('get', this.API, null).pipe(map(res => res.data)); 
  }

  // Swap with real monthly API when available
  getMockTrends(): { month: string; gc: number; sc: number }[] {
    return [
      { month: 'Aug', gc: 120, sc: 8200 },
      { month: 'Sep', gc: 135, sc: 8800 },
      { month: 'Oct', gc: 148, sc: 9100 },
      { month: 'Nov', gc: 155, sc: 9600 },
      { month: 'Dec', gc: 160, sc: 6600 },
      { month: 'Jan', gc: 165, sc: 10100 },
      { month: 'Feb', gc: 168, sc: 10300 },
      { month: 'Mar', gc: 174, sc: 10540 },
    ];
  }

  // refresh logic --start
  private refreshSubject = new Subject<void>();
  refresh$ = this.refreshSubject.asObservable();

  triggerRefresh() {
    this.refreshSubject.next();
  }
  // refresh logic --end
}